import HelloSign from "hellosign-embedded";
import React from "react";
import { trackEvent } from "./analytics";

interface Opts {
  testMode: boolean;
  clientId: string;
  metadata?: pendo.Metadata;
}

export const useHelloSign = (
  opts: Opts,
): [(iframeUrl: string
  ) => Promise<{ signatureId: string }>] => {
  const client = React.useMemo(
    () =>
    // @ts-ignore
      new HelloSign({ clientId: opts.clientId })
    , [],
  );

  const openModal = (url: string) => {
    client.off("sign");
    client.off("error");

    return new Promise<{ signatureId: string }>((resolve, reject) => {
      client.on("sign", resolve);
      client.on("error", () => {
        trackEvent("user:sign_failed", opts.metadata);
        reject(new Error("Signature error"));
      });
      client.on("cancel", () => {
        trackEvent("user:sign_cancelled", opts.metadata);
        reject(new Error("Signature flow cancelled"));
      });
      client.on("close", () => {
        trackEvent("user:sign_cancelled", opts.metadata);
        reject(new Error("Signature flow cancelled"));
      });
      client.on("finish", () => {
        trackEvent("user:sign_complete", opts.metadata);
        client.close();
        resolve({ signatureId: "" });
      });
      try {
        client.open(url, { testMode: opts.testMode });
      } catch {
        reject(new Error("Error opening signature modal"));
      }
    });
  };

  return [openModal];
};
